/* window.BotTts: каркас зовёт mount(#view), bind, capture и picker — как раньше.
   Группа «Озвучка» меню «Состояния» остаётся в каркасе, чтобы не появиться дважды. */
import { definePageModule } from '../../bridge/page-module';
import { bindTts, captureTts, destroyTts, getPicker } from './runtime';
import { Tts } from './Tts';

const extra: Record<string, unknown> = {
  bind: bindTts,
  capture: captureTts,
};
Object.defineProperty(extra, 'picker', { enumerable: true, get: () => getPicker() });

export function installTts() {
  definePageModule({
    global: 'BotTts',
    PREFIX: '',
    TESTS: [],
    S: {},
    Page: Tts,
    beforeUnmount() {
      destroyTts();
    },
    extra,
  });
}
